
import { mapGetters } from 'vuex';
import Vue from 'vue';

import FicheTiers from './fiche-tiers.vue';
import FicheSalarie from './fiche-salarie.vue';
import FicheAlerte from './fiche-alerte.vue';
import HistoriqueCommande from '../historique-commandes/index.vue';

import { RouteName } from '@/router/routes';

export default Vue.extend({
  name: 'MonCompte',
  components: {
    FicheTiers,
    FicheSalarie,
    FicheAlerte,
    HistoriqueCommande
  },
  computed: {
    ...mapGetters({ infoTiers: 'tiers/infosTiers' })
  },
  methods: {
    gotoHisoriqueCommande () {
      this.$router.push({ name: RouteName.MAIN_HISTORIQUE_COMMANDES });
    }
  }
});
